import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, RssIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-white border-t border-gray-100 pt-16 pb-8" data-id="element-75">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-77">

          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-78">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-79">
              <span className="font-signature text-2xl text-coral" data-id="element-80">HelgiG</span>
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed" data-id="element-81">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Explore */}
          <div data-id="element-82">
            <h4 className="font-heading font-bold text-charcoal mb-4" data-id="element-83">
              {t('footer.explore')}
            </h4>
            <ul className="space-y-2 text-sm text-gray-500" data-id="element-84">
              <li data-id="element-85">
                <Link to="/" className="hover:text-coral transition-colors" data-id="element-86">
                  {t('footer.home')}
                </Link>
              </li>
              <li data-id="element-87">
                <Link to="/about" className="hover:text-coral transition-colors" data-id="element-88">
                  {t('footer.about')}
                </Link>
              </li>
              <li data-id="element-89">
                <Link to="/services" className="hover:text-coral transition-colors" data-id="element-90">
                  {t('footer.services')}
                </Link>
              </li>
              <li data-id="element-91">
                <Link to="/contact" className="hover:text-coral transition-colors" data-id="element-92">
                  {t('footer.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Challenge areas */}
          <div data-id="element-93">
            <h4 className="font-heading font-bold text-charcoal mb-4" data-id="element-94">
              {t('footer.servicesTitle')}
            </h4>
            <ul className="space-y-2 text-sm text-gray-500" data-id="element-95">
              <li data-id="element-96">
                <Link to="/services/new-to-leadership" className="hover:text-coral transition-colors" data-id="element-97">
                  {t('footer.newToLeadership')}
                </Link>
              </li>
              <li data-id="element-98">
                <Link to="/services/conflict-and-conversations" className="hover:text-coral transition-colors" data-id="element-99">
                  {t('footer.conflictAndConversations')}
                </Link>
              </li>
              <li data-id="element-100">
                <Link to="/services/meetings-and-facilitation" className="hover:text-coral transition-colors" data-id="element-101">
                  {t('footer.meetingsAndFacilitation')}
                </Link>
              </li>
              <li data-id="element-102">
                <Link to="/services/leading-in-complexity" className="hover:text-coral transition-colors" data-id="element-103">
                  {t('footer.leadingInComplexity')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div data-id="element-104">
            <h4 className="font-heading font-bold text-charcoal mb-4" data-id="element-105">
              {t('footer.connectTitle')}
            </h4>
            <div className="flex space-x-3" data-id="element-106">
              <a href="https://www.linkedin.com/in/helgig" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="bg-gray-100 p-2 rounded-full text-gray-600 hover:bg-teal hover:text-white transition-colors" data-id="element-107">
                <LinkedinIcon size={20} data-id="element-108" />
              </a>
              <a href="https://helgig.substack.com" target="_blank" rel="noopener noreferrer" aria-label="Substack" className="bg-gray-100 p-2 rounded-full text-gray-600 hover:bg-coral hover:text-white transition-colors" data-id="element-109">
                <RssIcon size={20} data-id="element-110" />
              </a>
            </div>
            <p className="text-xs text-gray-400 mt-4 leading-relaxed" data-id="element-111">
              {t('footer.substackNote')}
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400" data-id="element-112">
          <p data-id="element-113">
            &copy; {new Date().getFullYear()} Helgi Gudmundsson / Orgz ehf. {t('footer.copyright')}
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-114">
            <Link to="/privacy" className="hover:text-gray-600 transition-colors" data-id="element-115">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms" className="hover:text-gray-600 transition-colors" data-id="element-116">
              {t('footer.terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}